import { InvoicesPrefillPostingDateWith } from "@/common/types/enums";
import { booleanField, optionField } from "@/common/utils/form/fieldTypes";

export const allow_invoice_linking_only_with_cases_of_same_or_connected_company =
	"allow_invoice_linking_only_with_cases_of_same_or_connected_company";

export const reverse_accounting_journal_entries =
	"reverse_accounting_journal_entries";

export const invoices_prefill_allocation_date_with =
	"invoices_prefill_allocation_date_with";

export const invoices_ocr_engine = "invoices_ocr_engine";

export type InvoicesAllocationDateFillWith =
	| {
			label: string;
			value: string;
	  }
	| string
	| null;

export type InvoicesOCREngine =
	| {
			label: string;
			value: string;
	  }
	| string
	| null;

export const invoicesPreFilledAllocationDateOptions = Object.entries(
	InvoicesPrefillPostingDateWith,
).map(([key, value]) => ({
	label: key.replace(/([a-z])([A-Z])/g, "$1 $2"),
	value,
}));

export const invoicesOCREngineOptions = [
	{ label: "Textract", value: "textract" },
	{ label: "AI", value: "ai" },
];

export type InvoicesType = {
	[allow_invoice_linking_only_with_cases_of_same_or_connected_company]: boolean;
	[reverse_accounting_journal_entries]: boolean;
	[invoices_prefill_allocation_date_with]: InvoicesAllocationDateFillWith;
	[invoices_ocr_engine]: InvoicesOCREngine;
};

const config = {
	[allow_invoice_linking_only_with_cases_of_same_or_connected_company]:
		booleanField(),
	[reverse_accounting_journal_entries]: booleanField(),
	[invoices_prefill_allocation_date_with]: optionField(),
	[invoices_ocr_engine]: optionField(),
};

export default config;
